export function filterObjectByFields(obj: Record<string, any>, fields: string[], entityPrefix?: string) {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => fields.includes(`${entityPrefix ?? ''}${key}`)));
}
